import React, { Component } from 'react'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
// import { Link } from 'react-router-dom'

import s from './Seighth.module.scss'

class Seighth extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      showAnimation: false
    }
    this.seighthRef = React.createRef();
    this._handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener("scroll", this._handleScroll);
    // 初始检查一次位置
    this._handleScroll();
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this._handleScroll);
  }

  handleScroll() {
    const clientHeight = document.documentElement.clientHeight;
    if (this.seighthRef.current) {
      const seighthRect = this.seighthRef.current.getBoundingClientRect();
      
      // 当元素的顶部进入视口60%时触发动画
      if (seighthRect.top < clientHeight * 0.8 && !this.state.showAnimation) {
        this.setState({ showAnimation: true });
      }
    }
  }

  render() {
    const { locale } = this.props
    const { showAnimation } = this.state;
    const isEnglish = locale.indexOf('US') > -1
    
    // 根据语言选择背景图片
    const item2BackgroundClass = isEnglish ? s.item2_en : s.item2_cn
    const item3BackgroundClass = isEnglish ? s.item3_en : s.item3_cn

    return (
      <div className={s.seighth} ref={this.seighthRef}>
        {/* 标题区域 */}
        <div className={s.title_container}>
          <div className={`${s.title} ${showAnimation ? s.animateIn : s.hidden}`}>
            <FormattedMessage id="gs3_seven_title" values={{br: <br />}} />
          </div>
        </div>
        
        {/* 内容区域 */}
        <div className={`${s.content_wrapper} `}>
          {/* 第一个全宽卡片 */}
          <div className={s.item1_container}>
            <div className={s.item1}>
              <div className={s.item1_title}>
                <FormattedMessage id="gs3_seven_item1_title" />
              </div>
              <div className={s.item1_desc}>
                <FormattedMessage id="gs3_seven_item1_desc" />
              </div>
            </div>
          </div>
          
          {/* 底部两个卡片容器 */}
          <div className={s.bottom_container}>
            {/* 左侧卡片 */}
            <div className={`${s.item2} ${item2BackgroundClass}`}>
              <div className={s.item2_content}>
                <div className={s.item2_title}>
                  <FormattedMessage id="gs3_seven_item2_title" />
                </div>
                <div className={s.item2_desc}>
                  <FormattedMessage id="gs3_seven_item2_desc" />
                </div>
              </div>
            </div>
            
            {/* 右侧卡片 */}
            <div className={`${s.item3} ${item3BackgroundClass}`}>
              <div className={s.item3_title}>
                <FormattedMessage id="gs3_seven_item3_title" />
              </div>
              <div className={s.item3_desc}>
                <FormattedMessage id="gs3_seven_item3_desc" />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  locale: state.language,
})

const SEighth = connect(mapStateToProps)(Seighth)

export default SEighth
